import type { GetChargesByRelatedDriverResponse } from "@qivia/schemas-ev-charging";

export const getReimbursementTotal = (
  charges: GetChargesByRelatedDriverResponse,
) =>
  charges
    .filter((charge) => !charge.excludedAt)
    .reduce((sum, charge) => sum + (charge.reimbursementAmount ?? 0), 0);
